module.exports = __webpack_public_path__ + "img/cnpc.e570ba5c.jpg";